import React from "react";
import { TextInput } from "react-native";
import QuantityField, { QuantityFieldProps } from "./QuantityField";
import { defaultCurrency } from "../utils";

export type MoneyFieldProps = QuantityFieldProps;

const MoneyField = ({
    left = defaultCurrency,
    decimalPlaces = 2,
    ref,
    ...props
}: MoneyFieldProps & { ref?: React.Ref<TextInput> }) => {
    return <QuantityField left={left} decimalPlaces={decimalPlaces} {...props} ref={ref} />;
};

export default MoneyField;
